var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h3", [_vm._v("Search for …")]),
    _vm._v(" "),
    _c("ul", { staticClass: "nav nav-tabs", attrs: { id: "searchTabs" } }, [
      _c(
        "li",
        {
          class: { active: _vm.activePattern === "simple" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              _vm.activePattern = "simple"
            },
          },
        },
        [
          _c("a", { staticClass: "querytype", attrs: { href: "#simple" } }, [
            _vm._v("Simple"),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          class: { active: _vm.activePattern === "extended" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              _vm.activePattern = "extended"
            },
          },
        },
        [
          _c("a", { staticClass: "querytype", attrs: { href: "#extended" } }, [
            _vm._v("Extended"),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.advancedEnabled
        ? _c(
            "li",
            {
              class: { active: _vm.activePattern === "advanced" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.activePattern = "advanced"
                },
              },
            },
            [
              _c(
                "a",
                { staticClass: "querytype", attrs: { href: "#advanced" } },
                [_vm._v("Advanced")]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "li",
        {
          class: { active: _vm.activePattern === "expert" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              _vm.activePattern = "expert"
            },
          },
        },
        [
          _c("a", { staticClass: "querytype", attrs: { href: "#expert" } }, [
            _vm._v("Expert"),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "tab-content" }, [
      _c(
        "div",
        {
          class: [
            "tab-pane form-horizontal",
            { active: _vm.activePattern === "simple" },
          ],
          attrs: { id: "simple" },
        },
        [
          _c(
            "div",
            { staticClass: "form-group form-group-lg" },
            [
              _c(
                "label",
                {
                  staticClass: "control-label",
                  attrs: {
                    for: _vm.firstMainAnnotation.id + "_" + _vm.uid,
                    title: _vm.firstMainAnnotation.description || undefined,
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.firstMainAnnotation.displayName) + "\n\t\t\t\t"
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.customAnnotations[_vm.firstMainAnnotation.id]
                ? _c("div", {
                    ref: "_simple",
                    attrs: {
                      "data-custom-annotation-root": _vm.firstMainAnnotation.id,
                      "data-is-simple": "true",
                    },
                  })
                : _c("Annotation", {
                    key:
                      "simple/" +
                      _vm.firstMainAnnotation.annotatedFieldId +
                      "/" +
                      _vm.firstMainAnnotation.id,
                    attrs: {
                      htmlId:
                        "simple/" +
                        _vm.firstMainAnnotation.annotatedFieldId +
                        "/" +
                        _vm.firstMainAnnotation.id,
                      annotation: _vm.firstMainAnnotation,
                      bare: "",
                      simple: "",
                    },
                  }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            "tab-pane form-horizontal",
            { active: _vm.activePattern === "extended" },
          ],
          attrs: { id: "extended" },
        },
        [
          _vm.useTabs
            ? [
                _c(
                  "ul",
                  {
                    staticClass: "nav nav-tabs subtabs",
                    staticStyle: { "padding-left": "15px" },
                  },
                  _vm._l(_vm.tabs, function (tab, index) {
                    return _c(
                      "li",
                      { key: index, class: { active: index === 0 } },
                      [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "#" + _vm.getTabId(tab.label),
                              "data-toggle": "tab",
                            },
                          },
                          [_vm._v(_vm._s(tab.label))]
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tab-content" },
                  _vm._l(_vm.tabs, function (tab, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        class: [
                          "tab-pane",
                          "annotation-container",
                          { active: index === 0 },
                        ],
                        attrs: { id: _vm.getTabId(tab.label) },
                      },
                      [
                        _vm._l(tab.entries, function (annotation) {
                          return [
                            _vm.customAnnotations[annotation.id]
                              ? _c("div", {
                                  key:
                                    _vm.getTabId(tab.label) +
                                    "/" +
                                    annotation.annotatedFieldId +
                                    "/" +
                                    annotation.id,
                                  ref:
                                    _vm.getTabId(tab.label) +
                                    "/" +
                                    annotation.annotatedFieldId +
                                    "/" +
                                    annotation.id,
                                  refInFor: true,
                                  attrs: {
                                    "data-custom-annotation-root":
                                      annotation.id,
                                  },
                                })
                              : _c("Annotation", {
                                  key:
                                    _vm.getTabId(tab.label) +
                                    "/" +
                                    annotation.annotatedFieldId +
                                    "/" +
                                    annotation.id,
                                  attrs: {
                                    htmlId:
                                      _vm.getTabId(tab.label) +
                                      "/" +
                                      annotation.annotatedFieldId +
                                      "/" +
                                      annotation.id,
                                    annotation: annotation,
                                  },
                                }),
                          ]
                        }),
                      ],
                      2
                    )
                  }),
                  0
                ),
              ]
            : [
                _vm._l(_vm.allAnnotations, function (annotation) {
                  return [
                    _vm.customAnnotations[annotation.id]
                      ? _c("div", {
                          key:
                            annotation.annotatedFieldId +
                            "/" +
                            annotation.id +
                            "/custom",
                          ref:
                            annotation.annotatedFieldId + "/" + annotation.id,
                          refInFor: true,
                          attrs: {
                            "data-custom-annotation-root": annotation.id,
                          },
                        })
                      : _c("Annotation", {
                          key:
                            annotation.annotatedFieldId +
                            "/" +
                            annotation.id +
                            "/builtin",
                          attrs: {
                            htmlId:
                              annotation.annotatedFieldId + "/" + annotation.id,
                            annotation: annotation,
                          },
                        }),
                  ]
                }),
              ],
          _vm._v(" "),
          _vm.withinOptions.length || _vm.within
            ? _c("div", { staticClass: "form-group" }, [
                _c("label", { staticClass: "col-xs-12 col-md-3" }, [
                  _vm._v("Within:"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "btn-group col-xs-12 col-md-9" },
                  _vm._l(_vm.withinOptions, function (option) {
                    return _c(
                      "button",
                      {
                        key: option.value,
                        class: [
                          "btn",
                          _vm.within === option.value
                            ? "active btn-primary"
                            : "btn-default",
                        ],
                        attrs: {
                          type: "button",
                          value: option.value,
                          title: option.title || undefined,
                        },
                        on: {
                          click: function ($event) {
                            _vm.within = option.value
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(option.label || option.value || "document")
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.splitBatchEnabled
            ? _c("div", { staticClass: "form-group" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-md-9 col-md-push-3 checkbox" },
                  [
                    _c("label", { attrs: { for: "extended_split_batch" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.splitBatch,
                            expression: "splitBatch",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          name: "extended_split_batch",
                          id: "extended_split_batch",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.splitBatch)
                            ? _vm._i(_vm.splitBatch, null) > -1
                            : _vm.splitBatch,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.splitBatch,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.splitBatch = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.splitBatch = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.splitBatch = $$c
                            }
                          },
                        },
                      }),
                      _vm._v(" Split batch queries\n\t\t\t\t\t"),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: ["tab-pane", { active: _vm.activePattern === "advanced" }],
          attrs: { id: "advanced" },
        },
        [
          _c("div", { ref: "querybuilder", attrs: { id: "querybuilder" } }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-default btn-sm",
              attrs: { type: "button" },
              on: { click: _vm.copyAdvancedQuery },
            },
            [_vm._v("Copy to CQL editor")]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: ["tab-pane", { active: _vm.activePattern === "expert" }],
          attrs: { id: "expert" },
        },
        [
          _c("h3", [_vm._v("Corpus Query Language:")]),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model.lazy",
                value: _vm.expert,
                expression: "expert",
                modifiers: { lazy: true },
              },
            ],
            staticClass: "form-control",
            attrs: { id: "querybox", name: "querybox", rows: "7" },
            domProps: { value: _vm.expert },
            on: {
              change: function ($event) {
                _vm.expert = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _vm.advancedEnabled
            ? _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-default",
                  attrs: {
                    type: "button",
                    name: "parseQuery",
                    id: "parseQuery",
                    title: "Edit your query in the querybuilder",
                  },
                  on: { click: _vm.parseQuery },
                },
                [_vm._v("Copy to query builder")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "btn btn-sm btn-default file-input-button",
              attrs: { for: "importQuery" },
            },
            [
              _vm._v("\n\t\t\t\tImport query\n\t\t\t\t"),
              _c("input", {
                attrs: {
                  type: "file",
                  name: "importQuery",
                  id: "importQuery",
                  accept: ".txt,text/plain",
                  title: "Import a previously downloaded query",
                },
                on: { change: _vm.importQuery },
              }),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "btn-group" }, [
            _c(
              "label",
              {
                staticClass: "btn btn-sm btn-default file-input-button",
                attrs: { for: "gapFilling" },
              },
              [
                _vm._v("\n\t\t\t\t\tGap-filling\n\t\t\t\t\t"),
                _c("input", {
                  attrs: {
                    type: "file",
                    name: "gapFilling",
                    id: "gapFilling",
                    accept: ".tsv,.csv,text/plain",
                    title:
                      "Upload a tab-separated list of values to substitute for gap values ('@@' in your query).",
                  },
                  on: { change: _vm.importGapFile },
                }),
              ]
            ),
            _vm._v(" "),
            _vm.gapValue != null
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-default btn-sm",
                    attrs: { type: "button", title: "Clear gap values" },
                    on: {
                      click: function ($event) {
                        _vm.gapValue = null
                      },
                    },
                  },
                  [_c("span", { staticClass: "fa fa-times" })]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.gapValue != null
            ? _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.lazy",
                    value: _vm.gapValue,
                    expression: "gapValue",
                    modifiers: { lazy: true },
                  },
                ],
                staticClass: "form-control gap-value-editor",
                attrs: { type: "area" },
                domProps: { value: _vm.gapValue },
                on: {
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.insertTabInText.apply(null, arguments)
                  },
                  change: function ($event) {
                    _vm.gapValue = $event.target.value
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.parseQueryError,
                  expression: "parseQueryError",
                },
              ],
              staticClass: "text-danger",
              attrs: { id: "parseQueryError" },
            },
            [
              _c("span", { staticClass: "fa fa-exclamation-triangle" }),
              _vm._v(" " + _vm._s(_vm.parseQueryError)),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.importQueryError,
                  expression: "importQueryError",
                },
              ],
              staticClass: "text-danger",
              attrs: { id: "importQueryError" },
            },
            [
              _c("span", { staticClass: "fa fa-exclamation-triangle" }),
              _vm._v(" " + _vm._s(_vm.importQueryError)),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }